import React from 'react';
import moment from 'moment';
import ReactTable from 'react-table';

const ErrorLogsContainerHOC = Component => {
  const StackTraceCell = ({ value, index }) => {
    return (
      <div
        className='error-log-item'
        onClick={e => $(e.currentTarget).toggleClass('open')}
        >
        <p>{value.stack || value.message}</p>
      </div>
    );
  };

  const columns = [
    {
      header: 'Time Stamp',
      accessor: 'timestamp',
      render: ({ value }) => moment(value).format('MMM DD YYYY, h:mm:ss a')
    },
    {
      header: 'Error',
      accessor: 'error',
      render: StackTraceCell,
      minWidth: 300
    }
  ];

  return props => (
    <Component
      {...props}
      columns={columns}
    />
  );
};

export default ErrorLogsContainerHOC;



// WEBPACK FOOTER //
// ./src/browser/components/error-logs/ErrorLogsContainerHOC.js